import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';

import { connect } from 'react-redux';

import 'react-dates/lib/css/_datepicker.css';
import Mapbox from '../shared/components/Mapbox';

import Geocoder from '../shared/components/Geocoder';

import { SAGA_GET_EVENTS } from './actions';
import { setBoundsEvents } from './actions';

const customStyles = {
  option: (base, state) => ({
    ...base,
    padding: 20,
    color: 'red',
  }),
  singleValue: (base, state) => {
    return { ...base };
  }
};

const pointStyles = (color) => ({
  width: '1em',
  height: '1em',
  borderRadius: '1em',
  display: 'inline-block',
  backgroundColor: color ? color : '#32ABE1',
  float: 'left',
  marginRight: 10,
});

const legendStyles = {
  display: 'flex',
  width: '100%',
  padding: '0.5em 0em',
  boxSizing: 'border-box',
  fontSize: '0.9em',
}

const EventTypeLegend = (props) => {
  return(
    <div style={legendStyles}>
      <span style={pointStyles(props.color)}></span>
      <span style={{ float: 'left', flexGrow: 1, padding: 0, margin: 0 }}>{props.label}</span>
    </div>
  )
}

class LocationData extends Component {
  constructor(props){
    super(props);
    this.state = {
      formattedAddress: '',
      bounds: null,

      startDate: moment().subtract('days', 1),
      endDate: moment(),
      focusedInput: null,
    }

    this.onCenterChanged = this.onCenterChanged.bind(this);
    this.onGeocoderChanged = this.onGeocoderChanged.bind(this);
    this.onDateRangeChanged = this.onDateRangeChanged.bind(this);
    this.onDateRangeFocusChanged = this.onDateRangeFocusChanged.bind(this);
  }

  componentDidMount(){
    this.props.getEvents(this.state.startDate.format("YYYY-MM-DD"),
                          this.state.endDate.format("YYYY-MM-DD"));
  }

  componentDidUnmout(){
    this.props.setBoundsEvents(null);
  }

  onCenterChanged(){
    this.props.updateBounds(null);
  }

  onGeocoderChanged(selected){
    this.props.updateBounds(selected.bounds);

    this.setState({
      location: selected.location,
      bounds: selected.bounds,
      formattedAddress: selected.formattedAddress,
    });
  }

  onDateRangeChanged({ startDate, endDate }){
    this.setState({
      startDate,
      endDate,
    });

    this.props.getEvents(moment(startDate).format("YYYY-MM-DD"),
                          moment(endDate).format("YYYY-MM-DD"));
  }

  onDateRangeFocusChanged(focusedInput) {
    this.setState({ 
      focusedInput 
    });
  }

  render() {
    const { state, props } = this;
    const { bounds } = state;

    let processedMarkers = props.loreEvents.map((event) => (
      {
        geo: {
          type: 'Point',
          coordinates: [
            event.long,
            event.lat,
          ],
        },
        htmlContent: `
          <div>
            <p><b>Lat/Long: </b>${event.lat},${event.long}</p>
            <p><b>Speed: </b>${event.deviceSpeed}</p>
            <p><b>Altitude: </b>${event.altitude}</p>
            <p><b>Horizontal Accuracy: </b>${event.horizontalAccuracy}</p>
            <p><b>Vertical Accuracy: </b>${event.verticalAccuracy}</p>
            <p><b>Event Time: </b>${moment(event.eventTime).toString()}</p>
          </div>`,
        color: '#32ABE1',
      }
    ));

    processedMarkers = [...processedMarkers, ...props.leeEvents.map((event) => (
      {
        geo: {
          type: 'Point',
          coordinates: event.checkIn.latLong,
        },
        htmlContent: `
          <div>
            <p><b>Check-In Time: </b>${moment(event.checkIn.time).toString()}</p>
            <p><b>Check-Out Time: </b>${event.checkOut ? moment(event.checkOut.time).toString(): ''}</p>
            <p><b>Device ID: </b>${event.deviceId}</p>
          </div>`,
        color: '#CC92FF',
      }
    ))];

    return (
      <div>
        <div className="content-area">
          <div className="container">
            <div style={{ position: 'relative'}}>
              <h3 className="heading">Location Data</h3>
              <h4 className="sub-heading" style={{ marginBottom: 26 }}>Collected from your mobile</h4>
              <div style={{ width: 400, right: 0, top: 0, position: 'absolute' }}>
                <div style={{ right: 0}}>
                  <DateRangePicker
                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                    startDateId="start_date_id" // PropTypes.string.isRequired,
                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                    endDateId="end_date_id" // PropTypes.string.isRequired,
                    onDatesChange={this.onDateRangeChanged} // PropTypes.func.isRequired,
                    focusedInput={state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={this.onDateRangeFocusChanged} // PropTypes.func.isRequired,
                    isOutsideRange={() => (false)}
                  />
                </div>
              </div>
            </div>
            <div style={{ width: '100%', height: 400, paddingBottom: 42, position: 'relative' }}>
                <Mapbox 
                  drawMode={false}
                  editMode={false} 
                  markers={processedMarkers}
                  mapBounds={props.bounds} 
                  mapCenter={null} 
                  centerChanged={this.onCenterChanged}
                />
            </div>
          </div>
        </div>
        
        <div className="content-area" style={{ marginTop: 16 }}>
          <div className="container" style={{ paddingBottom: 40 }}>
            <div style={{ 
                width: '50%', 
                float: 'left', 
                borderRight: '1px solid rgba(0,0,0,0.18)',
                paddingRight: 42,
              }}>
              <div className="form-field" style={{ width: '100%' }}>
                <Geocoder onResultSelect={this.onGeocoderChanged} />
              </div>
            </div>

            <div style={{ width: 300, float: 'right', padding: '0 2em', boxSizing: 'border-box' }}>
              <div>
                <h5 style={{ margin: '0.8em 0'}}>Collected location data</h5>
                <div>
                  <EventTypeLegend label="Enriched" />
                  <EventTypeLegend label="On-Premise" color="#CC92FF" />
                </div>
              </div>
            </div>
            <div style={{ clear: 'both' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

LocationData.propTypes = {
  getEvents: PropTypes.func,
  updateBounds: PropTypes.func,

  loreEvents: PropTypes.array,
  leeEvents: PropTypes.array,
  loading: PropTypes.bool,
  bounds: PropTypes.shape({
    northeast: PropTypes.shape({
      lat: PropTypes.number,
      long: PropTypes.number,
    }),
    southwest: PropTypes.shape({
      lat: PropTypes.number,
      long: PropTypes.number,
    }),
  }),
};

LocationData.default = {
  loreEvents: [],
  leeEvents: [],
  loading: true,
  bounds: null,
}

// Map props to the store

const mapStateToProps = (state) => ({
  loreEvents: state.events.get('loreEvents'),
  leeEvents: state.events.get('leeEvents'),
  loading: state.events.get('loading'),
  bounds: state.events.get('bounds'),
});

const mapDispatchToProps = (dispatch) => ({
  getEvents: (startDate, endDate) => {
    dispatch({
      type: SAGA_GET_EVENTS,
      payload: {
        startDate,
        endDate,
      },
    });
  },
  updateBounds: (bounds) => {
    dispatch(setBoundsEvents(bounds));
  }
});

const LocationDataContainer = connect(mapStateToProps,mapDispatchToProps)(LocationData);

export default LocationDataContainer;



// WEBPACK FOOTER //
// ./src/Events/LocationData.js